// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10 14H12C13.1 14 14 13.11 14 12V7.31C14 6.72 13.74 6.15 13.28 5.77L9.28 2.46C8.54 1.85 7.46 1.85 6.72 2.46L2.72 5.77C2.26 6.15 2 6.72 2 7.31V12C2 13.11 2.9 14 4 14H10ZM10 14V9.01C10 8.46 9.55 8.01 9 8.01H7C6.45 8.01 6 8.46 6 9.01V14',
];
